import "./YandexMap.css";

import React from "react";
import { useEffect, useRef, useState } from "react";
import { DistributionLayout } from "./DistributionLayout";
import { RoadsLayout } from "./RoadsLayout";
import { ControlsLayout } from "../controls/ControlsLayout";
import { useGraph } from "../graph/graph-context";

function YandexMap() {
  const [layoutParams, setLayoutParams] = useState([]);
  const [overlays, setOverlays] = useState([]);
  const [ymaps, setYmaps] = useState(null);
  const {graph, graphConfig} = useGraph()
  const hideLayerRef = useRef(null);

  useEffect(() => {
    if (ymaps != null) {
      ymaps.layers.remove(hideLayerRef.current);
      if (layoutParams.includes("hideMap") && hideLayerRef.current) {
        ymaps.layers.add(hideLayerRef.current);
      }
    }
  }, [layoutParams, ymaps, hideLayerRef]);

  useEffect(() => {
    console.log("useEffect.map");
    window.ymaps.ready(() => {
      const map = new window.ymaps.Map("map", {
        center: [61.784626, 34.345481],
        zoom: 12,
        controls: ["zoomControl"],
      });
      setYmaps(map);
      hideLayerRef.current = new window.ymaps.Layer("white_overlay.png", {
        projection: window.ymaps.projection.sphericalMercator,
      });

      const controlItems = [
        new window.ymaps.control.ListBoxItem({
          data: {
            content: "Скрыть карту",
            layoutParam: "hideMap",
          },
          options: {
            selectOnClick: false,
            checkbox: true,
          },
        }),
      ];
      const controlBox = new window.ymaps.control.ListBox({
        items: controlItems,
        data: {
          content: "Параметры отображения",
        },
      });
      controlBox.events.add("click", (e) => {
        var item = e.get("target");
        if (item !== controlBox) {
          const param = item.data.get("layoutParam");
          if (item.isSelected()) {
            item.deselect();
            setLayoutParams(layoutParams.filter((e) => e === param));
          } else {
            item.select();
            setLayoutParams([...layoutParams, param]);
          }
        }
      });

      map.controls.add(controlBox, { float: "left" });
    });
  }, []);


  return (
    <div>
      <div id="map" className="map"></div>
      {ymaps && (
        <div>
          {
            graphConfig.nodeAttributes.map((attr) => {
              return <DistributionLayout
              key={attr}
              map={ymaps}
              graph={graph}
              parameter={attr}
              enabled={overlays.includes(attr)}/>
            })
          }
          <ControlsLayout
            map={ymaps}
            overlays={overlays}
            setOverlays={setOverlays}
          />
          
          <RoadsLayout
            map={ymaps}
            graph={graph}
            parameter={'flow'}
            enabled={overlays.includes("flow")}
          />

          <RoadsLayout
            map={ymaps}
            graph={graph}
            parameter={'time'}
            enabled={overlays.includes("time")}
          />
          <RoadsLayout
            map={ymaps}
            graph={graph}
            parameter={null}
            enabled={overlays.includes("roads")}
          />
           
        </div>
      )}
    </div>
  );
}

export default YandexMap;
